import { FC } from 'react'
import { CountdownTimer } from 'components/CountdownTimer'
import { cn } from '@wellesley/ui'
import { RefreshCcw } from 'lucide-react'
import { useSwitchState } from 'hooks/useSwitchState'

export type ResendProps = {
  countdownTime: number
  onResend?: () => void
}
export const Resend: FC<ResendProps> = ({ countdownTime, onResend }) => {
  const [isCountdownActive, active, deActive] = useSwitchState(true)

  const handleResend = () => {
    onResend && onResend()
    active()
  }

  return (
    <div className="flex justify-center">
      {isCountdownActive && (
        <div className="gap-xxxs flex items-center">
          <div className="text-base font-normal text-gray-400">
            You will be able to send a new code within
          </div>
          <CountdownTimer
            isActive={isCountdownActive}
            initialSeconds={countdownTime}
            onComplete={deActive}
          />
        </div>
      )}
      {!isCountdownActive && (
        <div
          className={cn(
            'gap-xxs flex cursor-pointer flex-row items-center justify-center text-base font-semibold text-blue-500',
          )}
          onClick={handleResend}
        >
          <RefreshCcw size={18} />
          <span>Resend verification code</span>
        </div>
      )}
    </div>
  )
}
